function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Checkbox",
  width: 16,
  height: 16,
  rx: 4,
  fill: "#3aabf2"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_17._Icon_Small_Check",
  "data-name": "17. Icon/Small/Check"
}, /*#__PURE__*/React.createElement("path", {
  id: "check",
  d: "M3.448,6.775,1.135,4.462a.665.665,0,0,0-.94.94L2.982,8.188a.664.664,0,0,0,.94,0l7.053-7.053a.665.665,0,0,0-.94-.94Z",
  transform: "translate(2.552 4.005)",
  fill: "#fff"
}));

var SvgIconCheckboxOn = function SvgIconCheckboxOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3._Form_Small_.Resources_Checkbox_On",
    "data-name": "3. Form/Small/.Resources/Checkbox/On",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckboxOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-checkbox-on.aaa1fd87.svg";
export { ForwardRef as ReactComponent };